import { FC, useMemo } from "react";
import { CartesianGrid, XAxis, YAxis, ResponsiveContainer, Tooltip, BarChart, Bar } from "recharts";
import EnterpriseComplianceDashboardChartHeader from "../components/EcdChartHeader";
import { AdequacyBreakdownData, EcdTrendingArrowEnum, GapOverviewData } from "../interfaces";
import { CustomXAxisTickOffsetX, gapOverviewCustomTooltip, getPercentChange, getYAxisWidth } from "../utility";

interface GapOverviewChartProps {
  gapOverviewData: GapOverviewData[];
  adequacyBreakdownData: AdequacyBreakdownData;
  barHoverBackground?: string;
  gapsArray: string[];
  isExport: boolean;
}

const GapOverviewChart: FC<GapOverviewChartProps> = (props: GapOverviewChartProps) => {

  const totalGapsPercent = useMemo(() => {
    return getPercentChange(
      parseInt(props.adequacyBreakdownData?.overallGapCountPrior, 10),
      parseInt(props.adequacyBreakdownData?.overallGapCount, 10)
    );
  }, [props.adequacyBreakdownData]);

  const yAxisWidth = useMemo(() => {
    const values = props.gapOverviewData.map((g) => g.gapCount);
    return getYAxisWidth(values);
  }, [props.gapOverviewData]);

  return (
    <div>
      <div className="d-inline-flex justify-content-around col-12">
        <EnterpriseComplianceDashboardChartHeader
          trendArrow={props.adequacyBreakdownData?.overallGapCountTrend}
          label="Total Gaps"
          number={parseInt(props.adequacyBreakdownData?.overallGapCount, 10)}
          percentage={totalGapsPercent}
        />
        <EnterpriseComplianceDashboardChartHeader
          trendArrow={EcdTrendingArrowEnum.Unknown}
          label="New Gaps"
          number={parseInt(props.adequacyBreakdownData?.newGaps, 10)}
          percentage={null}
        />
      </div>
      <div style={{ height: "230px", width: "100%" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={400}
            data={props.gapOverviewData}
            margin={{
              bottom: 0,
              left: 32,
              top: 10,
            }}
          >
            {!props.isExport && (<Tooltip
              content={(props) => gapOverviewCustomTooltip(props)}
              cursor={{ fill: props.barHoverBackground }}
              itemStyle={{ background: "white", color: "black" }}
            />)}
            <CartesianGrid strokeDasharray="0 1" />
            <XAxis
              dataKey="week"
              tickSize={12}
              tickLine={false}
              interval={"preserveStartEnd"}
              height={46}
              tick={<CustomXAxisTickOffsetX />}
            />
            <YAxis
              width={yAxisWidth}
              allowDecimals={false}
              tickFormatter={(tick: number) => tick.toLocaleString()}
              tickLine={false}
            />
            <Bar
              dataKey="gapCount"
              fill={props.gapsArray[2]}
              name="Gaps"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default GapOverviewChart;